import React from "react";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";

const ResumeTable = ({ data }) => {
  console.log(data);
  return (
    <div>
      <TableHeader />
      <TableRow data={data} />
    </div>
  );
};

export default ResumeTable;
